import { Routes } from '@angular/router';
import { AuthGuard } from './core/auth/guards/auth';
import { GuestGuard } from './core/auth/guards/guest';
import { MetaGuard } from './core/guards/meta.guard';

const accountRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/account/account-dashboard/account-dashboard.page').then(
        (m) => m.AccountDashboardPage,
      ),
    pathMatch: 'full',
  },
  {
    path: 'downloads',
    loadComponent: () =>
      import('./pages/account/account-downloads/account-downloads.page').then(
        (m) => m.AccountDownloadsPage,
      ),
  },

  {
    path: 'dreambox',
    loadComponent: () =>
      import('./pages/account/account-dreambox/account-dreambox.page').then(
        (m) => m.AccountDreamboxPage,
      ),
  },
  {
    path: 'invoices',
    loadComponent: () =>
      import('./pages/account/account-invoices/account-invoices.page').then(
        (m) => m.AccountInvoicesPage,
      ),
  },
  {
    path: 'profile',
    loadComponent: () =>
      import('./pages/account/account-profile/account-profile.page').then(
        (m) => m.AccountProfilePage,
      ),
  },
  {
    path: 'change-password',
    loadComponent: () =>
      import(
        './pages/account/account-change-password/account-change-password.page'
      ).then((m) => m.AccountChangePasswordPage),
  },
  {
    path: '**',
    redirectTo: '',
  },
];

const authRoutes: Routes = [
  {
    path: 'sign-in',
    loadComponent: () =>
      import('./pages/auth/sign-in/sign-in.page').then((m) => m.SignInPage),
  },
  {
    path: 'sign-up',
    loadComponent: () =>
      import('./pages/auth/sign-up/sign-up.page').then((m) => m.SignUpPage),
  },
  {
    path: 'confirm-sign-up/:token',
    loadComponent: () =>
      import('./pages/auth/confirm-sign-up/confirm-sign-up.page').then(
        (m) => m.ConfirmSignUpPage,
      ),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./pages/auth/forgot-password/forgot-password.page').then(
        (m) => m.ForgotPasswordPage,
      ),
  },
  {
    path: 'reset-password/:token',
    loadComponent: () =>
      import('./pages/auth/reset-password/reset-password.page').then(
        (m) => m.ResetPasswordPage,
      ),
  },
  {
    path: 'check-oauth-token',
    loadComponent: () =>
      import('./pages/auth/check-oauth-token/check-oauth-token.page').then(
        (m) => m.CheckOauthTokenPage,
      ),
  },
  { path: '**', redirectTo: 'sign-in' },
];

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/index/index.page').then((m) => m.IndexPage),
    pathMatch: 'full',
    canActivate: [MetaGuard],
  },
  {
    path: 'account',
    loadComponent: () =>
      import('./pages/account/account.page').then((m) => m.AccountPage),
    canActivate: [AuthGuard, MetaGuard],
    children: accountRoutes,
  },
  {
    path: 'auth',
    loadComponent: () =>
      import('./pages/auth/auth.page').then((m) => m.AuthPage),
    canActivate: [GuestGuard, MetaGuard],
    children: authRoutes,
  },
  {
    path: 'cart',
    loadComponent: () =>
      import('./pages/cart/cart.page').then((m) => m.CartPage),
    canActivate: [MetaGuard],
  },
  {
    path: 'gallery',
    loadComponent: () =>
      import('./pages/gallery/gallery.page').then((m) => m.GalleryPage),
  },
  {
    path: 'item/:id',
    loadComponent: () =>
      import('./pages/item/item.page').then((m) => m.ItemPage),
  },
  // {
  //   path: 'plans',
  //   loadComponent: () =>
  //     import('./pages/plans/plans.page').then((m) => m.PlansPage),
  // },
  {
    path: 'membership-agreement',
    loadComponent: () =>
      import('./pages/membership-agreement/membership-agreement.page').then(
        (m) => m.MembershipAgreementPage,
      ),
    canActivate: [MetaGuard],
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./pages/privacy-policy/privacy-policy.page').then(
        (m) => m.PrivacyPolicyPage,
      ),
    canActivate: [MetaGuard],
  },
  {
    path: 'terms-of-use',
    loadComponent: () =>
      import('./pages/terms-of-use/terms-of-use.page').then(
        (m) => m.TermsOfUsePage,
      ),
    canActivate: [MetaGuard],
  },
  {
    path: 'about',
    loadComponent: () =>
      import('./pages/about/about.page').then((m) => m.AboutPage),
    canActivate: [MetaGuard],
  },
  {
    path: 'contacts',
    loadComponent: () =>
      import('./pages/contacts/contacts.page').then((m) => m.ContactsPage),
    canActivate: [MetaGuard],
  },
  {
    path: 'faq',
    loadComponent: () => import('./pages/faq/faq.page').then((m) => m.FaqPage),
    canActivate: [MetaGuard],
  },
  {
    path: 'refund-policy',
    loadComponent: () =>
      import('./pages/refund-policy/refund-policy.page').then(
        (m) => m.RefundPolicyPage,
      ),
    canActivate: [MetaGuard],
  },
  {
    path: 'licensing-policy',
    loadComponent: () =>
      import('./pages/licensing-policy/licensing-policy.page').then(
        (m) => m.LicensingPolicyPage,
      ),
    canActivate: [MetaGuard],
  },
  {
    path: 'cookie-policy',
    loadComponent: () =>
      import('./pages/cookie-policy/cookie-policy.page').then(
        (m) => m.CookiePolicyPage,
      ),
    canActivate: [MetaGuard],
  },
  {
    path: 'success',
    loadComponent: () =>
      import('./pages/success/success.page').then((m) => m.SuccessPage),
    canActivate: [MetaGuard],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
